export default __webpack_public_path__ + "static/media/I-2025.a0cd8173.pdf";